module.exports = __webpack_public_path__ + "static/media/soundcloud.3df24462.svg";